import { Directive, ElementRef, OnInit, Renderer2 } from '@angular/core';

/**
 * Directive for the start icon (visible when switch is unchecked). Apply to an SVG or icon element: `<svg
 * hxSwitchStartIcon>`
 */
@Directive({
  selector: '[hxSwitchStartIcon]',
  standalone: true,
  host: {
    class: 'hx-switch-icon hx-switch-icon--start',
  },
})
export class HxSwitchStartIconDirective implements OnInit {
  constructor(
    private elementRef: ElementRef<HTMLElement>,
    private renderer: Renderer2
  ) {}

  /** Ensure initial hidden state; consumer toggles via component effect */
  ngOnInit(): void {
    this.renderer.setStyle(this.elementRef.nativeElement, 'display', 'none', 2);
  }

  /** Show the start icon (when switch is unchecked) */
  show(): void {
    this.renderer.setStyle(this.elementRef.nativeElement, 'display', 'inline-block', 2); // 2 = RendererStyleFlags2.Important
  }

  /** Hide the start icon (when switch is checked) */
  hide(): void {
    this.renderer.setStyle(this.elementRef.nativeElement, 'display', 'none', 2); // 2 = RendererStyleFlags2.Important
  }
}

/** Directive for the end icon (visible when switch is checked). Apply to an SVG or icon element: `<svg hxSwitchEndIcon>` */
@Directive({
  selector: '[hxSwitchEndIcon]',
  standalone: true,
  host: {
    class: 'hx-switch-icon hx-switch-icon--end',
  },
})
export class HxSwitchEndIconDirective implements OnInit {
  constructor(
    private elementRef: ElementRef<HTMLElement>,
    private renderer: Renderer2
  ) {}

  /** Ensure initial hidden state; consumer toggles via component effect */
  ngOnInit(): void {
    this.renderer.setStyle(this.elementRef.nativeElement, 'display', 'none', 2);
  }

  /** Show the end icon (when switch is checked) */
  show(): void {
    this.renderer.setStyle(this.elementRef.nativeElement, 'display', 'inline-block', 2); // 2 = RendererStyleFlags2.Important
  }

  /** Hide the end icon (when switch is unchecked) */
  hide(): void {
    this.renderer.setStyle(this.elementRef.nativeElement, 'display', 'none', 2); // 2 = RendererStyleFlags2.Important
  }
}
